import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, CalendarDays, Plus, MessageCircle, User } from "lucide-react";

export default function MobileNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const routes = [
    { path: "/feed", label: "Home", icon: Home },
    { path: "/activities", label: "Events", icon: CalendarDays },
    { path: "/messages", label: "Messages", icon: MessageCircle, badge: 2 },
    { path: "/profile", label: "Profile", icon: User },
  ];

  const getCurrentValue = () => {
    return routes.findIndex((route) => route.path === location.pathname);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      {/* Navbar Container */}
      <div className="relative bg-white shadow-lg rounded-t-3xl border-t border-gray-100">
        {/* Center Button */}
        <div className="absolute left-1/2 -translate-x-1/2 -top-5">
          <button
            onClick={() => navigate("/newactivity")}
            className="bg-orange-500 hover:bg-orange-600 w-16 h-16 rounded-full flex items-center justify-center shadow-lg border-4 border-white transition-all hover:scale-105"
          >
            <Plus className="w-8 h-8 text-white" />
          </button>
        </div>

        {/* Navigation Items */}
        <div className="flex justify-around items-center h-16 px-4">
          {routes.map((route, index) => {
            const isActive = getCurrentValue() === index;
            // Añadir espacio en el centro para el botón flotante
            if (index === 2) {
              return (
                <React.Fragment key="spacer">
                  <div className="w-16"></div>
                  <button
                    onClick={() => navigate(route.path)}
                    className={`flex flex-col items-center text-xs font-medium ${
                      isActive ? "text-orange-500" : "text-gray-500"
                    } hover:text-orange-500 transition-colors relative`}
                  >
                    <div className="relative">
                      <route.icon
                        size={24}
                        className={`${
                          isActive ? "translate-y-[-2px]" : ""
                        } transition-transform`}
                      />
                      {route.badge && (
                        <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
                          {route.badge}
                        </span>
                      )}
                    </div>
                    <span
                      className={`mt-1 ${
                        isActive ? "opacity-100" : "opacity-70"
                      } transition-opacity`}
                    >
                      {route.label}
                    </span>
                  </button>
                </React.Fragment>
              );
            }
            return (
              <button
                key={index}
                onClick={() => navigate(route.path)}
                className={`flex flex-col items-center text-xs font-medium ${
                  isActive ? "text-orange-500" : "text-gray-500"
                } hover:text-orange-500 transition-colors relative`}
              >
                <div className="relative">
                  <route.icon
                    size={24}
                    className={`${
                      isActive ? "translate-y-[-2px]" : ""
                    } transition-transform`}
                  />
                  {route.badge && (
                    <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
                      {route.badge}
                    </span>
                  )}
                </div>
                <span
                  className={`mt-1 ${
                    isActive ? "opacity-100" : "opacity-70"
                  } transition-opacity`}
                >
                  {route.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
